
import Tabela from './tabela'
import { SituacaoPropostaEnum } from "../../classes/SituacaoPropostaEnum";
import * as _ from 'lodash'

export default {
  name: 'proposta',
  components: { Tabela },
  props: {
    proposta: {
      type: Object,
      default: null
    },
    propostaComparacao: {
      type: Object,
      default: null
    },
    situacao: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      situacaoPropostaEnum: SituacaoPropostaEnum,
      camposDiferentes: []
    }
  },
  methods: {
    init () {
    },
    isCampoDiferente (campo) {
      return this.camposDiferentes.includes(campo)
    },
    setCamposDiferentes () {
      if (this.propostaComparacao === null) return
      if (this.proposta === null) return

      let propostaComparacao = Object.assign({}, this.propostaComparacao)
      let proposta = Object.assign({}, this.proposta)

      // Igualando propriedades
      propostaComparacao.destinacoes = ""
      proposta.destinacoes = ""

      const diff = _.omitBy(proposta, function (v, k) {
        return propostaComparacao[k] === v;
      });

      this.camposDiferentes = Object.keys(diff);
    }
  },
  mounted () {
    if (this.propostaComparacao !== null) {
      this.init()
      this.setCamposDiferentes()
    }
  },
  computed: {
  }
}
